/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as QuotesRouteImport } from './routes/quotes'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CreateIndexRouteImport } from './routes/create/index'
import { Route as SignupStep2RouteImport } from './routes/signup/step2'
import { Route as SignupStep1RouteImport } from './routes/signup/step1'
import { Route as SignupQuickStartRouteImport } from './routes/signup/quick-start'
import { Route as QuotesStep3RouteImport } from './routes/quotes/step3'
import { Route as QuotesStep2RouteImport } from './routes/quotes/step2'
import { Route as QuotesStep1RouteImport } from './routes/quotes/step1'
import { Route as QuotesBuildingRouteImport } from './routes/quotes/building'
import { Route as BuilderSlugRouteImport } from './routes/builder/$slug'
import { Route as ProposalTokenIndexRouteImport } from './routes/proposal/$token/index'
import { Route as ProposalTokenSummaryRouteImport } from './routes/proposal/$token/summary'
import { Route as ProposalTokenEditRouteImport } from './routes/proposal/$token/edit'
import { Route as BuilderSlugLogosRouteImport } from './routes/builder/$slug.logos'
import { Route as BuilderSlugLogosLaunchRouteImport } from './routes/builder/$slug.logos.launch'

const NotFoundLazyRouteImport = createFileRoute('/not-found')()
const MaintenanceLazyRouteImport = createFileRoute('/maintenance')()
const ForbiddenLazyRouteImport = createFileRoute('/forbidden')()
const OauthTestLazyRouteImport = createFileRoute('/oauth/test')()
const OauthLogoutLazyRouteImport = createFileRoute('/oauth/logout')()
const OauthCallbackLazyRouteImport = createFileRoute('/oauth/callback')()
const BuilderSlugIndexLazyRouteImport = createFileRoute('/builder/$slug/')()

const NotFoundLazyRoute = NotFoundLazyRouteImport.update({
  id: '/not-found',
  path: '/not-found',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/not-found.lazy').then((d) => d.Route))
const MaintenanceLazyRoute = MaintenanceLazyRouteImport.update({
  id: '/maintenance',
  path: '/maintenance',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/maintenance.lazy').then((d) => d.Route))
const ForbiddenLazyRoute = ForbiddenLazyRouteImport.update({
  id: '/forbidden',
  path: '/forbidden',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/forbidden.lazy').then((d) => d.Route))
const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const QuotesRoute = QuotesRouteImport.update({
  id: '/quotes',
  path: '/quotes',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CreateIndexRoute = CreateIndexRouteImport.update({
  id: '/create/',
  path: '/create/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/create/index.lazy').then((d) => d.Route))
const OauthTestLazyRoute = OauthTestLazyRouteImport.update({
  id: '/oauth/test',
  path: '/oauth/test',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/oauth/test.lazy').then((d) => d.Route))
const OauthLogoutLazyRoute = OauthLogoutLazyRouteImport.update({
  id: '/oauth/logout',
  path: '/oauth/logout',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/oauth/logout.lazy').then((d) => d.Route))
const OauthCallbackLazyRoute = OauthCallbackLazyRouteImport.update({
  id: '/oauth/callback',
  path: '/oauth/callback',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/oauth/callback.lazy').then((d) => d.Route),
)
const SignupStep2Route = SignupStep2RouteImport.update({
  id: '/step2',
  path: '/step2',
  getParentRoute: () => SignupRoute,
} as any)
const SignupStep1Route = SignupStep1RouteImport.update({
  id: '/step1',
  path: '/step1',
  getParentRoute: () => SignupRoute,
} as any)
const SignupQuickStartRoute = SignupQuickStartRouteImport.update({
  id: '/quick-start',
  path: '/quick-start',
  getParentRoute: () => SignupRoute,
} as any)
const QuotesStep3Route = QuotesStep3RouteImport.update({
  id: '/step3',
  path: '/step3',
  getParentRoute: () => QuotesRoute,
} as any)
const QuotesStep2Route = QuotesStep2RouteImport.update({
  id: '/step2',
  path: '/step2',
  getParentRoute: () => QuotesRoute,
} as any)
const QuotesStep1Route = QuotesStep1RouteImport.update({
  id: '/step1',
  path: '/step1',
  getParentRoute: () => QuotesRoute,
} as any)
const QuotesBuildingRoute = QuotesBuildingRouteImport.update({
  id: '/building',
  path: '/building',
  getParentRoute: () => QuotesRoute,
} as any)
const BuilderSlugRoute = BuilderSlugRouteImport.update({
  id: '/builder/$slug',
  path: '/builder/$slug',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/builder/$slug.lazy').then((d) => d.Route))
const BuilderSlugIndexLazyRoute = BuilderSlugIndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BuilderSlugRoute,
} as any).lazy(() =>
  import('./routes/builder/$slug.index.lazy').then((d) => d.Route),
)
const ProposalTokenIndexRoute = ProposalTokenIndexRouteImport.update({
  id: '/proposal/$token/',
  path: '/proposal/$token/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProposalTokenSummaryRoute = ProposalTokenSummaryRouteImport.update({
  id: '/proposal/$token/summary',
  path: '/proposal/$token/summary',
  getParentRoute: () => rootRouteImport,
} as any)
const ProposalTokenEditRoute = ProposalTokenEditRouteImport.update({
  id: '/proposal/$token/edit',
  path: '/proposal/$token/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const BuilderSlugLogosRoute = BuilderSlugLogosRouteImport.update({
  id: '/logos',
  path: '/logos',
  getParentRoute: () => BuilderSlugRoute,
} as any).lazy(() =>
  import('./routes/builder/$slug.logos.lazy').then((d) => d.Route),
)
const BuilderSlugLogosLaunchRoute = BuilderSlugLogosLaunchRouteImport.update({
  id: '/launch',
  path: '/launch',
  getParentRoute: () => BuilderSlugLogosRoute,
} as any).lazy(() =>
  import('./routes/builder/$slug.logos.launch.lazy').then((d) => d.Route),
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/quotes': typeof QuotesRouteWithChildren
  '/signup': typeof SignupRouteWithChildren
  '/forbidden': typeof ForbiddenLazyRoute
  '/maintenance': typeof MaintenanceLazyRoute
  '/not-found': typeof NotFoundLazyRoute
  '/builder/$slug': typeof BuilderSlugRouteWithChildren
  '/quotes/building': typeof QuotesBuildingRoute
  '/quotes/step1': typeof QuotesStep1Route
  '/quotes/step2': typeof QuotesStep2Route
  '/quotes/step3': typeof QuotesStep3Route
  '/signup/quick-start': typeof SignupQuickStartRoute
  '/signup/step1': typeof SignupStep1Route
  '/signup/step2': typeof SignupStep2Route
  '/oauth/callback': typeof OauthCallbackLazyRoute
  '/oauth/logout': typeof OauthLogoutLazyRoute
  '/oauth/test': typeof OauthTestLazyRoute
  '/create/': typeof CreateIndexRoute
  '/builder/$slug/logos': typeof BuilderSlugLogosRouteWithChildren
  '/proposal/$token/edit': typeof ProposalTokenEditRoute
  '/proposal/$token/summary': typeof ProposalTokenSummaryRoute
  '/proposal/$token/': typeof ProposalTokenIndexRoute
  '/builder/$slug/': typeof BuilderSlugIndexLazyRoute
  '/builder/$slug/logos/launch': typeof BuilderSlugLogosLaunchRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/quotes': typeof QuotesRouteWithChildren
  '/signup': typeof SignupRouteWithChildren
  '/forbidden': typeof ForbiddenLazyRoute
  '/maintenance': typeof MaintenanceLazyRoute
  '/not-found': typeof NotFoundLazyRoute
  '/quotes/building': typeof QuotesBuildingRoute
  '/quotes/step1': typeof QuotesStep1Route
  '/quotes/step2': typeof QuotesStep2Route
  '/quotes/step3': typeof QuotesStep3Route
  '/signup/quick-start': typeof SignupQuickStartRoute
  '/signup/step1': typeof SignupStep1Route
  '/signup/step2': typeof SignupStep2Route
  '/oauth/callback': typeof OauthCallbackLazyRoute
  '/oauth/logout': typeof OauthLogoutLazyRoute
  '/oauth/test': typeof OauthTestLazyRoute
  '/create': typeof CreateIndexRoute
  '/builder/$slug/logos': typeof BuilderSlugLogosRouteWithChildren
  '/proposal/$token/edit': typeof ProposalTokenEditRoute
  '/proposal/$token/summary': typeof ProposalTokenSummaryRoute
  '/proposal/$token': typeof ProposalTokenIndexRoute
  '/builder/$slug': typeof BuilderSlugIndexLazyRoute
  '/builder/$slug/logos/launch': typeof BuilderSlugLogosLaunchRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/quotes': typeof QuotesRouteWithChildren
  '/signup': typeof SignupRouteWithChildren
  '/forbidden': typeof ForbiddenLazyRoute
  '/maintenance': typeof MaintenanceLazyRoute
  '/not-found': typeof NotFoundLazyRoute
  '/builder/$slug': typeof BuilderSlugRouteWithChildren
  '/quotes/building': typeof QuotesBuildingRoute
  '/quotes/step1': typeof QuotesStep1Route
  '/quotes/step2': typeof QuotesStep2Route
  '/quotes/step3': typeof QuotesStep3Route
  '/signup/quick-start': typeof SignupQuickStartRoute
  '/signup/step1': typeof SignupStep1Route
  '/signup/step2': typeof SignupStep2Route
  '/oauth/callback': typeof OauthCallbackLazyRoute
  '/oauth/logout': typeof OauthLogoutLazyRoute
  '/oauth/test': typeof OauthTestLazyRoute
  '/create/': typeof CreateIndexRoute
  '/builder/$slug/logos': typeof BuilderSlugLogosRouteWithChildren
  '/proposal/$token/edit': typeof ProposalTokenEditRoute
  '/proposal/$token/summary': typeof ProposalTokenSummaryRoute
  '/proposal/$token/': typeof ProposalTokenIndexRoute
  '/builder/$slug/': typeof BuilderSlugIndexLazyRoute
  '/builder/$slug/logos/launch': typeof BuilderSlugLogosLaunchRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/quotes'
    | '/signup'
    | '/forbidden'
    | '/maintenance'
    | '/not-found'
    | '/builder/$slug'
    | '/quotes/building'
    | '/quotes/step1'
    | '/quotes/step2'
    | '/quotes/step3'
    | '/signup/quick-start'
    | '/signup/step1'
    | '/signup/step2'
    | '/oauth/callback'
    | '/oauth/logout'
    | '/oauth/test'
    | '/create/'
    | '/builder/$slug/logos'
    | '/proposal/$token/edit'
    | '/proposal/$token/summary'
    | '/proposal/$token/'
    | '/builder/$slug/'
    | '/builder/$slug/logos/launch'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/quotes'
    | '/signup'
    | '/forbidden'
    | '/maintenance'
    | '/not-found'
    | '/quotes/building'
    | '/quotes/step1'
    | '/quotes/step2'
    | '/quotes/step3'
    | '/signup/quick-start'
    | '/signup/step1'
    | '/signup/step2'
    | '/oauth/callback'
    | '/oauth/logout'
    | '/oauth/test'
    | '/create'
    | '/builder/$slug/logos'
    | '/proposal/$token/edit'
    | '/proposal/$token/summary'
    | '/proposal/$token'
    | '/builder/$slug'
    | '/builder/$slug/logos/launch'
  id:
    | '__root__'
    | '/'
    | '/quotes'
    | '/signup'
    | '/forbidden'
    | '/maintenance'
    | '/not-found'
    | '/builder/$slug'
    | '/quotes/building'
    | '/quotes/step1'
    | '/quotes/step2'
    | '/quotes/step3'
    | '/signup/quick-start'
    | '/signup/step1'
    | '/signup/step2'
    | '/oauth/callback'
    | '/oauth/logout'
    | '/oauth/test'
    | '/create/'
    | '/builder/$slug/logos'
    | '/proposal/$token/edit'
    | '/proposal/$token/summary'
    | '/proposal/$token/'
    | '/builder/$slug/'
    | '/builder/$slug/logos/launch'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  QuotesRoute: typeof QuotesRouteWithChildren
  SignupRoute: typeof SignupRouteWithChildren
  ForbiddenLazyRoute: typeof ForbiddenLazyRoute
  MaintenanceLazyRoute: typeof MaintenanceLazyRoute
  NotFoundLazyRoute: typeof NotFoundLazyRoute
  BuilderSlugRoute: typeof BuilderSlugRouteWithChildren
  OauthCallbackLazyRoute: typeof OauthCallbackLazyRoute
  OauthLogoutLazyRoute: typeof OauthLogoutLazyRoute
  OauthTestLazyRoute: typeof OauthTestLazyRoute
  CreateIndexRoute: typeof CreateIndexRoute
  ProposalTokenEditRoute: typeof ProposalTokenEditRoute
  ProposalTokenSummaryRoute: typeof ProposalTokenSummaryRoute
  ProposalTokenIndexRoute: typeof ProposalTokenIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/not-found': {
      id: '/not-found'
      path: '/not-found'
      fullPath: '/not-found'
      preLoaderRoute: typeof NotFoundLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/maintenance': {
      id: '/maintenance'
      path: '/maintenance'
      fullPath: '/maintenance'
      preLoaderRoute: typeof MaintenanceLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forbidden': {
      id: '/forbidden'
      path: '/forbidden'
      fullPath: '/forbidden'
      preLoaderRoute: typeof ForbiddenLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quotes': {
      id: '/quotes'
      path: '/quotes'
      fullPath: '/quotes'
      preLoaderRoute: typeof QuotesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/create/': {
      id: '/create/'
      path: '/create'
      fullPath: '/create/'
      preLoaderRoute: typeof CreateIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/test': {
      id: '/oauth/test'
      path: '/oauth/test'
      fullPath: '/oauth/test'
      preLoaderRoute: typeof OauthTestLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/logout': {
      id: '/oauth/logout'
      path: '/oauth/logout'
      fullPath: '/oauth/logout'
      preLoaderRoute: typeof OauthLogoutLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/oauth/callback': {
      id: '/oauth/callback'
      path: '/oauth/callback'
      fullPath: '/oauth/callback'
      preLoaderRoute: typeof OauthCallbackLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signup/step2': {
      id: '/signup/step2'
      path: '/step2'
      fullPath: '/signup/step2'
      preLoaderRoute: typeof SignupStep2RouteImport
      parentRoute: typeof SignupRoute
    }
    '/signup/step1': {
      id: '/signup/step1'
      path: '/step1'
      fullPath: '/signup/step1'
      preLoaderRoute: typeof SignupStep1RouteImport
      parentRoute: typeof SignupRoute
    }
    '/signup/quick-start': {
      id: '/signup/quick-start'
      path: '/quick-start'
      fullPath: '/signup/quick-start'
      preLoaderRoute: typeof SignupQuickStartRouteImport
      parentRoute: typeof SignupRoute
    }
    '/quotes/step3': {
      id: '/quotes/step3'
      path: '/step3'
      fullPath: '/quotes/step3'
      preLoaderRoute: typeof QuotesStep3RouteImport
      parentRoute: typeof QuotesRoute
    }
    '/quotes/step2': {
      id: '/quotes/step2'
      path: '/step2'
      fullPath: '/quotes/step2'
      preLoaderRoute: typeof QuotesStep2RouteImport
      parentRoute: typeof QuotesRoute
    }
    '/quotes/step1': {
      id: '/quotes/step1'
      path: '/step1'
      fullPath: '/quotes/step1'
      preLoaderRoute: typeof QuotesStep1RouteImport
      parentRoute: typeof QuotesRoute
    }
    '/quotes/building': {
      id: '/quotes/building'
      path: '/building'
      fullPath: '/quotes/building'
      preLoaderRoute: typeof QuotesBuildingRouteImport
      parentRoute: typeof QuotesRoute
    }
    '/builder/$slug': {
      id: '/builder/$slug'
      path: '/builder/$slug'
      fullPath: '/builder/$slug'
      preLoaderRoute: typeof BuilderSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/builder/$slug/': {
      id: '/builder/$slug/'
      path: '/'
      fullPath: '/builder/$slug/'
      preLoaderRoute: typeof BuilderSlugIndexLazyRouteImport
      parentRoute: typeof BuilderSlugRoute
    }
    '/proposal/$token/': {
      id: '/proposal/$token/'
      path: '/proposal/$token'
      fullPath: '/proposal/$token/'
      preLoaderRoute: typeof ProposalTokenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/proposal/$token/summary': {
      id: '/proposal/$token/summary'
      path: '/proposal/$token/summary'
      fullPath: '/proposal/$token/summary'
      preLoaderRoute: typeof ProposalTokenSummaryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/proposal/$token/edit': {
      id: '/proposal/$token/edit'
      path: '/proposal/$token/edit'
      fullPath: '/proposal/$token/edit'
      preLoaderRoute: typeof ProposalTokenEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/builder/$slug/logos': {
      id: '/builder/$slug/logos'
      path: '/logos'
      fullPath: '/builder/$slug/logos'
      preLoaderRoute: typeof BuilderSlugLogosRouteImport
      parentRoute: typeof BuilderSlugRoute
    }
    '/builder/$slug/logos/launch': {
      id: '/builder/$slug/logos/launch'
      path: '/launch'
      fullPath: '/builder/$slug/logos/launch'
      preLoaderRoute: typeof BuilderSlugLogosLaunchRouteImport
      parentRoute: typeof BuilderSlugLogosRoute
    }
  }
}

interface QuotesRouteChildren {
  QuotesBuildingRoute: typeof QuotesBuildingRoute
  QuotesStep1Route: typeof QuotesStep1Route
  QuotesStep2Route: typeof QuotesStep2Route
  QuotesStep3Route: typeof QuotesStep3Route
}

const QuotesRouteChildren: QuotesRouteChildren = {
  QuotesBuildingRoute: QuotesBuildingRoute,
  QuotesStep1Route: QuotesStep1Route,
  QuotesStep2Route: QuotesStep2Route,
  QuotesStep3Route: QuotesStep3Route,
}

const QuotesRouteWithChildren =
  QuotesRoute._addFileChildren(QuotesRouteChildren)

interface SignupRouteChildren {
  SignupQuickStartRoute: typeof SignupQuickStartRoute
  SignupStep1Route: typeof SignupStep1Route
  SignupStep2Route: typeof SignupStep2Route
}

const SignupRouteChildren: SignupRouteChildren = {
  SignupQuickStartRoute: SignupQuickStartRoute,
  SignupStep1Route: SignupStep1Route,
  SignupStep2Route: SignupStep2Route,
}

const SignupRouteWithChildren =
  SignupRoute._addFileChildren(SignupRouteChildren)

interface BuilderSlugLogosRouteChildren {
  BuilderSlugLogosLaunchRoute: typeof BuilderSlugLogosLaunchRoute
}

const BuilderSlugLogosRouteChildren: BuilderSlugLogosRouteChildren = {
  BuilderSlugLogosLaunchRoute: BuilderSlugLogosLaunchRoute,
}

const BuilderSlugLogosRouteWithChildren =
  BuilderSlugLogosRoute._addFileChildren(BuilderSlugLogosRouteChildren)

interface BuilderSlugRouteChildren {
  BuilderSlugLogosRoute: typeof BuilderSlugLogosRouteWithChildren
  BuilderSlugIndexLazyRoute: typeof BuilderSlugIndexLazyRoute
}

const BuilderSlugRouteChildren: BuilderSlugRouteChildren = {
  BuilderSlugLogosRoute: BuilderSlugLogosRouteWithChildren,
  BuilderSlugIndexLazyRoute: BuilderSlugIndexLazyRoute,
}

const BuilderSlugRouteWithChildren = BuilderSlugRoute._addFileChildren(
  BuilderSlugRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  QuotesRoute: QuotesRouteWithChildren,
  SignupRoute: SignupRouteWithChildren,
  ForbiddenLazyRoute: ForbiddenLazyRoute,
  MaintenanceLazyRoute: MaintenanceLazyRoute,
  NotFoundLazyRoute: NotFoundLazyRoute,
  BuilderSlugRoute: BuilderSlugRouteWithChildren,
  OauthCallbackLazyRoute: OauthCallbackLazyRoute,
  OauthLogoutLazyRoute: OauthLogoutLazyRoute,
  OauthTestLazyRoute: OauthTestLazyRoute,
  CreateIndexRoute: CreateIndexRoute,
  ProposalTokenEditRoute: ProposalTokenEditRoute,
  ProposalTokenSummaryRoute: ProposalTokenSummaryRoute,
  ProposalTokenIndexRoute: ProposalTokenIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
